import { lazy } from 'react';
import { Permission, type SkillManifest } from '@brandschutz/shared';
import type { FrontendSkill } from '../_core/registry';

/**
 * Schlanker Skill-Descriptor für das Bootstrap — Slot-Renderer ist React.lazy.
 * Wichtig: Der Tab zieht über das FormModal den Pruefer-Barrel (inkl.
 * PrueferListPage) mit — lazy hält diese Kette aus dem Entry-Bundle.
 */
const manifest: SkillManifest = {
  key: 'behoerdenvorgang',
  name: 'Behördenvorgänge',
  description:
    'Aktenzeichen, Phasen (Einreichung → Prüfung → Mängel → Nachreichung → Freigabe) und Fristen mit der Baubehörde.',
  category: 'core',
  version: '0.1.0',
  requiredPermissions: [Permission.PROJECT_READ, Permission.BEHOERDE_READ],
  enabledByDefault: true,
};

const BehoerdenvorgangTab = lazy(() =>
  import('./BehoerdenvorgangTab').then((m) => ({ default: m.BehoerdenvorgangTab })),
);

export const behoerdenvorgangSkill: FrontendSkill = {
  manifest,
  slots: {
    'project-detail.tabs': [
      {
        key: 'behoerdenvorgang-tab',
        order: 50,
        // @ts-expect-error Slot context shape ist dynamic — Caller liefert projectId + readOnly
        render: BehoerdenvorgangTab,
      },
    ],
  },
};
